import { render, staticRenderFns } from "./ErrorMessagePageTemplate.vue?vue&type=template&id=0698b5da&scoped=true&"
import script from "./ErrorMessagePageTemplate.vue?vue&type=script&lang=ts&"
export * from "./ErrorMessagePageTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorMessagePageTemplate.vue?vue&type=style&index=0&id=0698b5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0698b5da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardTitle,VImg})
